import React, {useEffect, useState} from 'react';
import {CircularProgress, Paper, Typography,} from '@material-ui/core';
import {Alert} from '@material-ui/lab';
import useStyles from '../styles/styles';
import {useMutation, useQuery} from '@apollo/react-hooks';
import {gql} from 'apollo-boost';
import VendorPauseDeleteConfirmation from "../components/VendorPause/VendorPauseDeleteConfirmation";
import VendorPauseTable from "../components/VendorPause/VendorPauseTable";

const VendorPauses = () => {
    const tableRef = React.createRef()

    const [sortedServicers, setSortedServicers] = useState(false);
    const [selectedRows, setSelectedRows] = useState([])
    const [open, setOpen] = useState(false)
    const classes = useStyles();
    /**
     * Fetch Vendor Pause Data
     */
    const {loading, error, data, refetch} = useQuery(gql`
        query AllVendorPause {
            allVendorPause {
                totalCount
                nodes {
                    id
                    campaign
                    portfolio
                    servicer
                    expiration
                    startDate
                    pauseSource
                }
            }
            allServicer {
                nodes {
                    id
                }
            }
            allPortfolio {
                nodes {
                    id
                }
            }
            allCampaign {
                nodes {
                    id
                    servicer {
                        id
                    }
                    portfolio {
                        id
                    }
                }
            }
        }
    `);

    /**
     * Create Vendor Pause Mutation
     */
    const [createVendorPause, {loading: createVendorPauseLoading}] = useMutation(gql`
        mutation createVendorPause(
            $input: CreateVendorPauseInput!
        ) {
            createVendorPause(
                input: $input
            ) {
                id
                campaign
                portfolio
                servicer
                expiration
                startDate
            }
        }
    `, {
        context: {
            clientName: "kgraphql"
        }
    });

    /**
     * Update Vendor Pause
     */
    const [updateVendorPause, {loading: updateVendorPauseLoading}] = useMutation(gql`
        mutation UpdateVendorPause(
            $input: UpdateVendorPauseInput!
        ) {
            updateVendorPause(
                input: $input
            ){
                updatedVendorPause
                {
                    id
                    campaign
                    portfolio
                    servicer
                    expiration
                    startDate
                }
                success
            }
        }
    `, {
        context: {
            clientName: "kgraphql"
        }
    });

    /**
     * Delete Vendor Pause
     */
    const [deleteVendorPause, {loading: deleteVendorPauseLoading}] = useMutation(gql`
        mutation deleteVendorPause(
            $input: DeleteVendorPauseInput!
        ) {
            deleteVendorPause(input: $input){
                success
            }
        }
    `, {
        context: {
            clientName: "kgraphql"
        }
    });

    /**
     * Delete Vendor Pause
     */
    const [deleteVendorPauseList, {loading: deleteVendorPauseListLoading}] = useMutation(gql`
        mutation deleteVendorPauseList(
           $input: DeleteVendorPauseListInput!
        ) {
            deleteVendorPauseList(input: $input){
                success
            }
        }
    `, {
        context: {
            clientName: "kgraphql"
        }
    });

    const handleKey = (e) => {
        if (e.key === 'Enter') {
            e.stopPropagation()
        }
    }

    /**
     * Create Array of Servicers that are linked to
     * Campaigns and portfolio
     */
    useEffect(() => {
        if (data && Object.keys(data).length) {
            let filterServicers = [];
            let servicersArr = [];
            data.allServicer.nodes.forEach(servicer => {
                filterServicers = [];
                filterServicers = data.allCampaign.nodes.filter(item => item.servicer.id === servicer.id);

                if (filterServicers) {
                    servicersArr.push({
                        servicer: servicer.id,
                        campaigns: filterServicers.map(item => item.id),
                        portfolio: [...new Set(filterServicers.map(item => item.portfolio.id))],
                    });
                }
            });

            setSortedServicers(servicersArr);
        }
    }, [data]);

    useEffect(() => {
        if (!createVendorPauseLoading) {
            refetch();
        }
    }, [createVendorPauseLoading]);

    useEffect(() => {
        if (!deleteVendorPauseLoading) {
            refetch();
        }
    }, [deleteVendorPauseLoading]);

    useEffect(() => {
        if (!updateVendorPauseLoading) {
            refetch();
        }
    }, [updateVendorPauseLoading]);

    useEffect(() => {
        if (!deleteVendorPauseListLoading) {
            refetch();
        }
    }, [deleteVendorPauseListLoading]);

    const onSelectionChange = (rows) => {

    }

    const handleClickOpen = () => {
        const selected = tableRef.current.dataManager.data.filter(o => o.tableData.checked)
        if (selected.length > 0) {
            setSelectedRows(selected)
            setOpen(true);
        }
    };

    const handleClose = (closing) => {
        setOpen(false);
        if (!closing) {
            deleteVendorPauseList({
                variables: {
                    input: {
                        idList: selectedRows.map(o => o.id)
                    }
                }
            });
        } else {
            setSelectedRows([])
        }
    };

    return (
        <>
            <Typography variant="h2">
                Vendor Pause Directives
            </Typography>
            {!loading && error ? (
                <Paper className={classes.paper}>
                    <Alert severity="error">There is an error!</Alert>
                    <pre>{JSON.stringify(error, null, 2)}</pre>
                </Paper>
            ) : null}
            {loading ? (
                <Paper className={classes.paper}>
                    <div className={classes.loadingBar}>
                        <CircularProgress
                            size={50}
                            thickness={4}
                        />
                    </div>
                </Paper>
            ) : null}
            {!loading && data && data.allVendorPause.nodes && sortedServicers ? (
                <>
                    <VendorPauseTable
                        data={data}
                        tableRef={tableRef}
                        selectedRows={selectedRows}
                        sortedServicers={sortedServicers}
                        createVendorPause={createVendorPause}
                        updateVendorPause={updateVendorPause}
                        deleteVendorPause={deleteVendorPause}
                        refetch={refetch}
                        onSelectionChange={onSelectionChange}
                        handleKey={handleKey}
                        handleClickConfirmationOpen={handleClickOpen}
                    />
                    <VendorPauseDeleteConfirmation
                        onClose={handleClose}
                        open={open}
                        selected={selectedRows}
                    />
                </>
            ) : null}
        </>
    );
};

export default VendorPauses;
